module.exports = __webpack_public_path__ + "static/img/produto_g.15be804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/rc/produto_g.png
// module id = TG6r
// module chunks = 0